import StorageTTL from "@components/StorageTTL";

const keyToken = "@RNAuth:token";
export const getTokenFromStorage = () => StorageTTL.getItem(keyToken);
